import script from "./Instructions.vue?vue&type=script&setup=true&lang=js"
export * from "./Instructions.vue?vue&type=script&setup=true&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=8a6d5c4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a6d5c4c"]])

export default __exports__